import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3.33333 3.33398V7.50065H3.81793M16.6151 9.16732C16.205 5.87872 13.3997 3.33398 9.99999 3.33398C7.20218 3.33398 4.8069 5.05746 3.81793 7.50065M3.81793 7.50065H7.49999M16.6667 16.6673V12.5007H16.1821M16.1821 12.5007C15.1931 14.9438 12.7978 16.6673 9.99999 16.6673C6.60031 16.6673 3.79499 14.1226 3.38491 10.834M16.1821 12.5007H12.5" />
  </svg>
);
